import AppLink from '@/components/common/AppLink';
import Logo from '@/components/general/Logo';
import React, { useEffect, useState } from 'react';
import styles from '../styles.module.scss';
import { useTranslations } from 'next-intl';
import AppImage from '@/components/common/AppImage';
import dynamic from 'next/dynamic';

const Animation = dynamic(() => import('@/components/general/Animation'), {
  ssr: false,
});

export default function LogoSection({ className = '', titleClass = '', logoClass = '' }) {
  const t = useTranslations('common');
    const [icon, setIcon] = useState<any>();

  useEffect(() => {
    const loadLogo = async () => {
      const logo = await import('@/public/imgs/motion/logo.json');
      setIcon(logo.default); // actual JSON data
    };

    loadLogo();
  }, []);
  return (
    <AppLink href="/" className={`${styles.logo} ${className}`}>
      {/* <Logo wrapper={`${styles.logoWrapper} ${logoClass}`}></Logo>
      <span className={`${styles.logo_txt} ${titleClass}`}>{t(`siteName`).toUpperCase()}</span> */}
      {/* <AppImage src="/imgs/logo.svg" className={`${styles.logoImage}`} /> */}
                <div className={`${styles.logoImage}`}>
            <Animation motion={JSON.stringify(icon)} speed={0.9} />
          </div>
    </AppLink>
  );
}
